export default __webpack_public_path__ + "static/media/mar.41ebbad3.JPG";